import queryString from "query-string";
import {
  GetCreatorUserList,
  GetDate,
  GetIdsList,
  GetImprestStateList,
  GetSortField,
  GetSortType,
  GetTextSearch,
  GetUseHasAppendix
} from "../../../../../assets/convertUrlFilter";
import { HASHTAG_ACTIVITY } from "../../../../../constants/sectionTypes";
import {
  ALL_IMPREST_STATES_ARRAY,
  APPENDIX,
  CREATOR_USER_IDS,
  END_DATE,
  IMPREST_IDS,
  IMPREST_STATES,
  IMPREST_STATES_FOR_OTHER_REPORTS,
  PAGE_NUM,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE,
  TEAM_IDS,
  TEXT_SEARCH,
  USER_IDS
} from "../../../../../constants/filters";

export default () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  return {
    file_type: "web",
    end_date: GetDate(filters[END_DATE]),
    start_date: GetDate(filters[START_DATE]),
    imprest_ids: GetIdsList(filters[IMPREST_IDS]),
    sort_field: GetSortField(filters[SORT_FIELD], HASHTAG_ACTIVITY),
    sort_type: GetSortType(filters[SORT_TYPE], HASHTAG_ACTIVITY),
    text_search: GetTextSearch(filters[TEXT_SEARCH]),
    page_number: filters[PAGE_NUM] ? filters[PAGE_NUM] : "",
    creator_user_ids: GetCreatorUserList(filters[CREATOR_USER_IDS]),
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
      filters[IMPREST_STATES],
      ALL_IMPREST_STATES_ARRAY
    )
  };
};
